<div class="templateExcelExportColumn">
  <dx-scroll-view showScrollbar="always">
    <div class="dx-fieldset">
      @if (showFormulaMode) {
        <div class="dx-field">
          <div class="dx-field-label" style="white-space: normal">{{ 'Formelmodus aktiv' | translate }}</div>
          <div class="dx-field-value">
            <dx-switch [(value)]="templateItem.isFormulaMode" (onValueChanged)="onFormulaModeChanged($event)"></dx-switch>
          </div>
        </div>
      }

      @if (isFormulaActive) {
        <np-formula-editor [placeholderItems]="formulaPlaceholders"
                           [placeholderDisplayExpr]="formulaPlaceholderLabel"
                           [placeholderName]="formulaPlaceholderName"
                           placeholderLabel="Feld"
                           placeholderSelectText="Feld wählen"
                           tooltipText="FormelModusExportTooltip"
                           [formula]="templateItem.formula"
                           [preview]="formulaError"
                           (formulaChange)="onFormulaChanged($event)"></np-formula-editor>
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Mapping' | translate }}</div>
          <div class="dx-field-value">
            <dx-select-box [dataSource]="mappings"
                           displayExpr="listName"
                           valueExpr="id"
                           placeholder=""
                           [(value)]="templateItem.mapping"
                           (onValueChanged)="update()"></dx-select-box>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Mapping anwenden' | translate }}</div>
          <div class="dx-field-value">
            <dx-radio-group [items]="mappingApplicationOptions"
                            displayExpr="displayExprExport"
                            valueExpr="valueExpr"
                            [(value)]="templateItem.isMappingAfterFormula"
                            (onValueChanged)="update()"></dx-radio-group>
          </div>
        </div>
      } @else {
      <div class="dx-fieldset-header">{{ 'Umrechnung' | translate }}</div>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Modus' | translate }}</div>
        <div class="dx-field-value">
          <dx-select-box [dataSource]="calculation"
                         [displayExpr]="displayExpr"
                         valueExpr="valueExpr"
                         placeholder=""
                         [(value)]="templateItem.calculation"
                         (onValueChanged)="update()"></dx-select-box>
        </div>
      </div>
      <div class="dx-field" *ngIf="templateItem.calculation == 'FACTOR'">
        <div class="dx-field-label">{{ 'Operator'| translate }}</div>
        <div class="dx-field-value">
            <dx-select-box [dataSource]="operators"
                           displayExpr="displayExprExport"
                           valueExpr="valueExpr"
                           placeholder=""
                           [(value)]="templateItem.factorOperator"
                           (onValueChanged)="update()"></dx-select-box>

        </div>
      </div>
      <div class="dx-field" *ngIf="templateItem.calculation == 'FACTOR' && templateItem.factorOperator != ''">
        <div class="dx-field-label">{{ 'Faktor'| translate }}</div>
        <div class="dx-field-value">
            <dx-number-box [(value)]="templateItem.factor"
                           [min]="1"
                           placeholder=""
                           (onValueChanged)="update()"></dx-number-box>

        </div>
      </div>

      <div class="dx-fieldset-header">{{ 'Einstellungen' | translate }}</div>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Zahlenformat' | translate }}</div>
        <div class="dx-field-value">
          <dx-select-box [dataSource]="numberformat"
                         displayExpr="displayExprExport"
                         valueExpr="valueExpr"
                         placeholder=""
                         [(value)]="templateItem.numberformat"
                         (onValueChanged)="update()"></dx-select-box>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Datumsformat' | translate }}</div>
        <div class="dx-field-value">
          <dx-select-box [dataSource]="dateformat"
                         displayExpr="displayExprExport"
                         valueExpr="valueExpr"
                         placeholder=""
                         [(value)]="templateItem.dateformat"
                         (onValueChanged)="update()"></dx-select-box>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Trennung' | translate }}</div>
        <div class="dx-field-value">
          <dx-select-box [dataSource]="seperator"
                         displayExpr="displayExprExport"
                         valueExpr="valueExpr"
                         placeholder=""
                         [(value)]="templateItem.seperator"
                         (onValueChanged)="update()"></dx-select-box>
        </div>
      </div>
      <div class="dx-field" *ngIf="!exportMode">
        <div class="dx-field-label" style="white-space: normal">{{ 'Nur beim ersten Import' | translate }}</div>
        <div class="dx-field-value">
          <dx-switch [(value)]="templateItem.isOnlyInitial" (onValueChanged)="update()"></dx-switch>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Mapping' | translate }}</div>
        <div class="dx-field-value">
          <dx-select-box [dataSource]="mappings"
                         displayExpr="listName"
                         valueExpr="id"
                         placeholder=""
                         [(value)]="templateItem.mapping"
                         (onValueChanged)="update()"></dx-select-box>
        </div>
      </div>
      <div class="dx-fieldset-header">Textzusatz</div>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Präfix' | translate }}</div>
        <div class="dx-field-value">
          <dx-text-box displayExpr="displayExprExport"
                       valueExpr="valueExpr"
                       placeholder=""
                       [(value)]="templateItem.prefix"
                       (onValueChanged)="update()"></dx-text-box>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Suffix' | translate }}</div>
        <div class="dx-field-value">
          <dx-text-box displayExpr="displayExprExport"
                       valueExpr="valueExpr"
                       labelMode=""
                       placeholder=""
                       [(value)]="templateItem.suffix"
                       (onValueChanged)="update()"></dx-text-box>
          </div>
        </div>

      @if (exportMode) {
        <div class="dx-fieldset-header">{{ 'Automatische Trennung' | translate }}</div>
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Modus' | translate }}</div>
          <div class="dx-field-value">
            <dx-select-box [dataSource]="splitModeOptions"
                           displayExpr="displayExprExport"
                           valueExpr="valueExpr"
                           [(value)]="templateItem.isSeparatorMode"
                           (onValueChanged)="update()"></dx-select-box>
          </div>
        </div>
        <div class="dx-field" *ngIf="templateItem.isSeparatorMode === false">
          <div class="dx-field-label" style="white-space: normal">{{ 'Max. Zeichenlänge' | translate }}</div>
          <div class="dx-field-value">
            <dx-number-box placeholder="Kein Limit"
                           [(value)]="templateItem.maxCharacters"
                           [min]="0"
                           (onValueChanged)="update()"></dx-number-box>
          </div>
        </div>
        <div class="dx-field" *ngIf="templateItem.isSeparatorMode === true">
          <div class="dx-field-label">{{ 'Trennzeichen' | translate }}</div>
          <div class="dx-field-value">
            <dx-select-box [dataSource]="splitSeparator"
                           displayExpr="displayExprExport"
                           valueExpr="valueExpr"
                           [(value)]="templateItem.seperator"
                           (onValueChanged)="update()"></dx-select-box>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Abschnitt' | translate }}</div>
          <div class="dx-field-value">
            <dx-number-box [(value)]="templateItem.section"
                           [min]="1"
                           (onValueChanged)="update()"></dx-number-box>
          </div>
        </div>
      }
      }
    </div>
  </dx-scroll-view>
</div>
